<template>
  <div id="app">
    <HeaderMain/>
    <div id="main">
      <router-view/>
      <FooterMain/>
    </div>
  </div>
</template>

<script>
import HeaderMain from '@/templates/_HeaderMain'
import FooterMain from '@/templates/_FooterMain'

export default {
  components: {
    HeaderMain,
    FooterMain
  }
}
</script>

<style lang="sass">

</style>
